<script>
  let downloads = [
    // {
    //   name: "Windows 11 설치 파일",
    //   image: "/images/windows11.jpg",
    //   description: "최신 Windows 11 설치 이미지 파일입니다.",
    //   link: "https://www.microsoft.com/ko-kr/software-download/windows11"
    // },
    // {
    //   name: "Windows 10 설치 파일",
    //   image: "/images/windows10.jpg",
    //   description: "안정적인 Windows 10 설치 이미지입니다.",
    //   link: "https://www.microsoft.com/ko-kr/software-download/windows10"
    // },
    {
      name: "Order Input Form",
      image: "../images/excel.png",
      description: "Order데이터 입력 디폴트양식입니다. 다운로드후 사용하세요.",
      link: "/downloads/DBTable_LOGTICS.xlsx"
    },
    {
      name: "barcode command",
      image: "../images/pdf.png",
      description: "명령어에 따른 바코드 입니다. 다운로드후 사용하세요.",
      link: "/downloads/barcode.pdf"
    }
  ];

  function downloadFile(url) {
    window.open(url, "_blank");
  }
</script>



<main>
  <h2 style="text-align: center; margin-top: 20px;"><i class="bi bi-file-earmark-arrow-down"></i>다운로드</h2>
  <div class="download-grid">
    {#each downloads as item}
      <div class="card">
        <img src={item.image} alt={item.name} />
        <h3>{item.name}</h3>
        <p>{item.description}</p>
        <button on:click={() => downloadFile(item.link)}>다운로드</button>
      </div>
    {/each}
  </div>
</main>


<style>
  main {
    width: 100%; 
    height: 100%;
  }
  .download-grid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
    padding: 20px;
  }
  .card {
    width: 300px;
    border: 1px solid #cfcfca;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s ease;
    background-color: #fcfcf8;
    text-align: center;
    padding-top: 12px; /* 카드 상단 여백 */

  }
  .card:hover {
    transform: translateY(-4px);
  }
  .card img {    
    height: 100px; /* 원하는 고정 높이 */
    object-fit: cover; /* 이미지 비율 유지하며 잘라냄 */
    /* border-bottom: 1px solid #eee; */
  }
  .card h3 {
    margin: 12px 0 6px;
    font-size: 1.1rem;
    color: #333;
  }

  .card p {
    font-size: 0.9rem;
    color: #666;
    padding: 0 12px;
    margin-bottom: 12px;
  }

  .card button {
    margin-bottom: 16px;
    padding: 8px 16px;
    background-color: #b6b69e;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .card button:hover {
    background-color:  #92927b;
  }
</style>